import { render, staticRenderFns } from "./BloodTest.vue?vue&type=template&id=358ad049&scoped=true"
import script from "./BloodTest.vue?vue&type=script&lang=js"
export * from "./BloodTest.vue?vue&type=script&lang=js"
import style0 from "./BloodTest.vue?vue&type=style&index=0&id=358ad049&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358ad049",
  null
  
)

export default component.exports